import {useTranslation} from "react-i18next";
import {useCallback} from "react";
import {Nil} from "./Types";

export const useTranslateCommon = () => {
    const {t} = useTranslation();
    return useCallback((prefix: string, option: string | Nil) => {
        if (option) {
            return t(`${prefix}.${option}`, option)
        } else {
            return option
        }
    }, [t])
}